import { CaptureMode } from '@data-terminal/shared-models/machine';
import { Consumption } from '@data-terminal/shared-models/consumption.model';
import { BookingCode } from '@data-terminal/shared-models/booking-code.enum';
import { Entity } from '@data-terminal/shared-models/common';

export interface TimeModeEntry extends Entity {
    email: string;
    shiftStart: string;
    deviceId: string;
    duration: number;
    startTime?: number;
    endTime?: number;
    status: TimeModeStatus;
    jobId?: string;
    activity: string;
    type: CaptureMode;
    goodAmount?: number;
    wasteAmount?: number;
    consumptions: Consumption[];
    workstepId?: string;
    submissionId: string;
    comment?: string;
    bookingCode?: BookingCode;
    assistants?: string[];
    defAssistantActivityId?: string;
    errorCode?: TimeModeErrorCode;
    errorDetails?: string;
}

export const TimeModeErrorCode = {
    JOB_NOT_FOUND: 'JOB_NOT_FOUND',
    WORKSTEP_NOT_FOUND: 'WORKSTEP_NOT_FOUND',
    USER_NOT_SIGNED_ON: 'USER_NOT_SIGNED_ON',
    NO_ACTIVITY: 'NO_ACTIVITY',
    TRANSFER_FAILED: 'TRANSFER_FAILED',
    MISSING_TIMES: 'MISSING_TIMES',
    UNKNOWN: 'UNKNOWN',
} as const;
export type TimeModeErrorCode = (typeof TimeModeErrorCode)[keyof typeof TimeModeErrorCode];

export enum TimeModeStatus {
    DRAFT = 'Draft',
    PENDING = 'Pending',
    SUBMITTED = 'Submitted',
    ERROR = 'Error',
}
